<div class="page-wrapper">
  <app-header></app-header>
  <div class="page-container">
    <router-outlet> </router-outlet>
  </div>
  <app-footer></app-footer>
</div>
